import styled, { keyframes } from 'styled-components';

export const Container = styled.div``;

export const AccordionHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);

  > div {
    display: flex;
    flex-direction: row;
    align-items: center; /* Changed from flex-start to center */
    justify-content: center;
    color: #323232;

    > h4 {
      width: 100%;
      font-family: 'RedHatDisplay-Medium';
      font-size: 1.1rem;
      line-height: 1.8rem;
      margin-right: 0.5rem;
    }

    > svg {
      width: 1.5rem;
      fill: #1e88e5;
      stroke: #1e88e5;
      stroke-width: 3;
      transition: transform 0.3s;

      &.open {
        transform: rotate(180deg);
      }
    }
  }
`;

const removeOverflow = keyframes`
  from { overflow: visible; }
  to { overflow: hidden; }
`;

const addOverflow = keyframes`
  from { overflow: hidden; }
  to { overflow: visible; }
`;

export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;

  overflow: visible;
  animation: 0.5s ${addOverflow} cubic-bezier(1, 0, 1, 0);

  transition: max-height 0.5s cubic-bezier(1, 0, 1, 0);
  height: auto;
  max-height: 9999px;

  > ul > li::after {
    transition: opacity 0.5s cubic-bezier(1, 0, 1, 0);
    opacity: 1;
  }

  &.collapsed {
    > ul > li::after {
      transition: opacity 0.5s cubic-bezier(0, 1, 0, 1);
      opacity: 0;
    }

    max-height: 0;
    transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);

    overflow: hidden;
    animation: 0.5s ${removeOverflow} cubic-bezier(0, 1, 0, 1);
  }
`;
